import { api } from "../../api/client";

export interface District {
  id: string;
  name: string;
  code: string;
  lat?: number | null;
  lng?: number | null;
}

export interface Constituency {
  id: string;
  name: string;
  code: string;
  districtId?: string | null;
  lat?: number | null;
  lng?: number | null;
}

export interface Ward {
  id: string;
  name: string;
  code: string;
  constituencyId: string;
  lat?: number | null;
  lng?: number | null;
}

export interface Branch {
  id: string;
  name: string;
  code: string;
  wardId: string;
  constituencyId: string;
  lat?: number | null;
  lng?: number | null;
}

interface List<T> {
  items: T[];
}

export interface MyScope {
  districts: District[];
  constituencies: Constituency[];
  wards: Ward[];
  branches: Branch[];
}

export const HierarchyApi = {
  // For capture forms: the user's accessible hierarchy slice. Doesn't
  // require ward.read / branch.read like the admin endpoints do.
  myScope: () => api<MyScope>("/me/scope"),

  listDistricts: () => api<List<District>>("/districts"),
  createDistrict: (body: { name: string; code: string; lat?: number; lng?: number }) =>
    api<District>("/districts", { method: "POST", body: JSON.stringify(body) }),
  updateDistrict: (id: string, body: Partial<{ name: string; code: string; lat: number; lng: number }>) =>
    api<District>(`/districts/${id}`, { method: "PATCH", body: JSON.stringify(body) }),
  deleteDistrict: (id: string) =>
    api<void>(`/districts/${id}`, { method: "DELETE" }),
  listConstituenciesInDistrict: (did: string) =>
    api<List<Constituency>>(`/districts/${did}/constituencies`),

  listConstituencies: () => api<List<Constituency>>("/constituencies"),
  createConstituency: (body: { name: string; code: string; districtId: string; lat?: number; lng?: number }) =>
    api<Constituency>("/constituencies", { method: "POST", body: JSON.stringify(body) }),
  updateConstituency: (id: string, body: Partial<{ name: string; code: string; districtId: string }>) =>
    api<Constituency>(`/constituencies/${id}`, { method: "PATCH", body: JSON.stringify(body) }),
  deleteConstituency: (id: string) =>
    api<void>(`/constituencies/${id}`, { method: "DELETE" }),

  listWards: (cid: string) => api<List<Ward>>(`/constituencies/${cid}/wards`),
  createWard: (cid: string, body: { name: string; code: string }) =>
    api<Ward>(`/constituencies/${cid}/wards`, { method: "POST", body: JSON.stringify(body) }),
  updateWard: (id: string, body: Partial<{ name: string; code: string }>) =>
    api<Ward>(`/wards/${id}`, { method: "PATCH", body: JSON.stringify(body) }),
  deleteWard: (id: string) =>
    api<void>(`/wards/${id}`, { method: "DELETE" }),

  listBranches: (wid: string) => api<List<Branch>>(`/wards/${wid}/branches`),
  createBranch: (wid: string, body: { name: string; code: string }) =>
    api<Branch>(`/wards/${wid}/branches`, { method: "POST", body: JSON.stringify(body) }),
  updateBranch: (id: string, body: Partial<{ name: string; code: string }>) =>
    api<Branch>(`/branches/${id}`, { method: "PATCH", body: JSON.stringify(body) }),
  deleteBranch: (id: string) =>
    api<void>(`/branches/${id}`, { method: "DELETE" }),
};
